export {default as crossfilter} from './src/CrossFilter';
export {default as resolvefilter} from './src/ResolveFilter';



// WEBPACK FOOTER //
// ./~/vega-crossfilter/index.js